import { GenericFormState } from "../../../components/generic-form/GenericForm.types";
import { CreateDocumentCategoryDTO } from "../../../entities/IDocumentCategory";

export const isDisabledArchiveStartingPoint = (state: GenericFormState<CreateDocumentCategoryDTO>): boolean => {
  return +state.archivePeriod.value === 0;
};
